import { BookOpen, Globe, Lightbulb } from "lucide-react";
import ShowcaseSlider from "./SliderSlide";
import Banner from "./Banner"
import { useNavigate } from "react-router-dom";

export default function HomeScreen() {
  const navigate = useNavigate();
  return (
    <>
      {      <Banner />      }
      <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl sm:text-7xl font-bold text-gray-900 leading-tight">
            What if cracking UPSC civil services was simpler?
          </h1>
          <p className="mt-6 text-xl text-gray-600 leading-relaxed">
            Walk into the exam knowing you've covered everything that matters{" "}
            <br />
            —no guesswork, no wasted effort.
          </p>
          <p className="mt-1 text-xl text-gray-600 leading-relaxed">
            At Civilscode, we make sure you study smart, not just hard.
          </p>
          <button
            className="mt-10 px-8 py-4 bg-primary-color text-white text-lg font-semibold rounded-lg border border-black 
               hover:shadow-[6px_6px_0px_black] 
               hover:translate-y-[-5px] 
               transition-all duration-300 ease-in-out"
            onClick={() => navigate("/signup")}
          >
            Start Learning Now
          </button>
        </div>
      </div>
      <ShowcaseSlider />
      {/* Vision Section */}
      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-[var(--textmain1)]">Our philosophy</h2>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
              In a world where UPSC civil services preparation can feel like an
              endless maze, CIVILSCODE is here to keep your path clear and
              sharp. With our technology, we cut through the complexity so you
              can focus on hitting your mark. Together, we'll turn complexity
              into clarity and ambition into achievement.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-center w-12 h-12 bg-primary-color rounded-lg mb-4">
                <BookOpen className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Comprehensive Learning
              </h3>
              <p className="text-gray-600">
                Dive into our meticulously crafted 'NCERT Simplified' series and
                explore our '360-Degree Notes'.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-center w-12 h-12 bg-primary-color rounded-lg mb-4">
                <Lightbulb className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Innovative Technology
              </h3>
              <p className="text-gray-600">
                Experience our pioneering 'Content Personalization Technology'
                that adapts to your learning style.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-center w-12 h-12 bg-primary-color rounded-lg mb-4">
                <Globe className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Anywhere Access</h3>
              <p className="text-gray-600">
                Study at your pace, on your terms, whether you're at home, in a
                café, or on the move.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
